import jbAPI from "./jobboard";

console.log("search api ");

export const jobListingsBySearch = async (candidate_id, token, filters = {}) => {
  try {
    const {
      keyword,
      location,
      company,                // ✅ added company
      job_type,               // ✅ added job type (work_mode)
      min_experience_required,
      max_experience_required,
      min_salary,
      max_salary,
      sort_by,
    } = filters;

    // Build query parameters dynamically
    const params = new URLSearchParams();
    if (keyword) params.append("keyword", keyword);
    if (location) params.append("location", location);
    if (company) params.append("company", company); // ✅ company name
    if (job_type) params.append("job_type", job_type);
    if (min_experience_required) params.append("min_experience_required", min_experience_required);
    if (max_experience_required) params.append("max_experience_required", max_experience_required);
    if (min_salary) params.append("min_salary", min_salary);
    if (max_salary) params.append("max_salary", max_salary);
    if (sort_by) params.append("sort_by", sort_by);

    const response = await jbAPI.get(`/search?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Failed to fetch job listings:", error);
    throw error;
  }
};


export const updateBasicInfo = async (appUserId, candidatePayload, token) => {
  try {
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    // If payload is FormData, set correct Content-Type
    if (candidatePayload instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
    }

    const response = await jbAPI.put(
      `/jobseeker/profile/${appUserId}`,
      candidatePayload,
      { headers }
    );

    return response.data;
  } catch (error) {
    console.error("Failed to update candidate detail:", error);
    throw error;
  }
};


// Candidate Skills

export const fetchCandidateSkillbyID = async (candidate_id, token) => {
  try {
    const response = await jbAPI.get(`/jobseeker/skills/${candidate_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });   
    return response.data;
  } catch (error) {
    console.error("Failed to fetch candidate detail:", error);
    throw error;
  }
};

// Candiadate Experiences

export const fetchCandidateExperiencebyID = async (candidate_id, token) => {
  try {
    const response = await jbAPI.get(`/jobseeker/experiences/${candidate_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });   
    return response.data;
  } catch (error) {
    console.error("Failed to fetch candidate detail:", error);
    throw error;
  }
};

// Candidate Education

export const fetchCandidateEducationsbyID = async (candidate_id, token) => {
  try {
    const response = await jbAPI.get(`/jobseeker/educations/${candidate_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });   
    return response.data;
  } catch (error) {
    console.error("Failed to fetch candidate detail:", error);
    throw error;
  }
};

export const deleteResume = async (appUserId, token) => {
  try {
    const response = await jbAPI.delete(`/jobseeker/profile/${appUserId}/resume`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to delete resume:", error);
    throw error;
  }
};
